/* =============================================================================
   LOOMA — account / content controllers (spec §4.5–4.9)
   <looma-article> reading-progress bar
   <looma-copy>     click-to-copy (Qikink tracking number)
   <looma-track>    order-tracking form → Qikink URL (validate ^#?\d{4,}$)
   <looma-accordion> FAQ (guarded; mirrors looma-product.js contract)
   ========================================================================== */
(function () {
  'use strict';

  if (!customElements.get('looma-article')) {
    customElements.define('looma-article', class extends HTMLElement {
      connectedCallback() {
        var bar = this.querySelector('[data-progress]');
        if (!bar) return;
        var self = this;
        var onScroll = function () {
          var rect = self.getBoundingClientRect();
          var total = self.offsetHeight - window.innerHeight;
          var done = Math.min(1, Math.max(0, -rect.top / (total || 1)));
          bar.style.width = (done * 100).toFixed(2) + '%';
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }
    });
  }

  if (!customElements.get('looma-copy')) {
    customElements.define('looma-copy', class extends HTMLElement {
      connectedCallback() {
        var btn = this.querySelector('[data-copy-btn]');
        var val = this.getAttribute('data-value') || '';
        if (!btn) return;
        var self = this;
        var label = btn.querySelector('[data-copy-label]');
        var orig = label ? label.textContent : '';
        btn.addEventListener('click', function () {
          var done = function () {
            self.classList.add('is-copied');
            if (label) label.textContent = self.getAttribute('data-copied') || 'Copied';
            setTimeout(function () {
              self.classList.remove('is-copied');
              if (label) label.textContent = orig;
            }, 1600);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(val).then(done).catch(done);
          } else {
            var t = document.createElement('textarea');
            t.value = val; document.body.appendChild(t); t.select();
            try { document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(t); done();
          }
        });
      }
    });
  }

  if (!customElements.get('looma-track')) {
    customElements.define('looma-track', class extends HTMLElement {
      connectedCallback() {
        var form = this.querySelector('form');
        if (!form) return;
        var self = this;
        var base = this.getAttribute('data-track-base') || '';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var order = (self.querySelector('[name="order"]') || {}).value || '';
          order = order.trim();
          if (!/^#?\d{4,}$/.test(order)) {
            self.classList.add('is-error');
            return;
          }
          self.classList.remove('is-error');
          var clean = order.replace(/^#/, '');
          var url = base ? base.replace('{order}', encodeURIComponent(clean)) : '';
          if (url) window.open(url, '_blank', 'noopener');
        });
      }
    });
  }

  if (!customElements.get('looma-accordion')) {
    customElements.define('looma-accordion', class extends HTMLElement {
      connectedCallback() {
        var trigs = [].slice.call(this.querySelectorAll('.accordion__trig'));
        trigs.forEach(function (t) {
          var p = t.nextElementSibling;
          if (t.getAttribute('aria-expanded') === 'true' && p) p.style.maxHeight = p.scrollHeight + 'px';
          t.addEventListener('click', function () {
            var open = t.getAttribute('aria-expanded') === 'true';
            trigs.forEach(function (o) {
              o.setAttribute('aria-expanded', 'false');
              if (o.nextElementSibling) o.nextElementSibling.style.maxHeight = '0px';
            });
            if (!open && p) { t.setAttribute('aria-expanded', 'true'); p.style.maxHeight = p.scrollHeight + 'px'; }
          });
        });
      }
    });
  }
})();
